import React from "react";
import * as Lucide from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export const ACTION_TYPES = {
  phone: { label: "Phone Call", icon: "Phone", color: "#171717" },
  whatsapp: { label: "WhatsApp", icon: "MessageCircle", color: "#25D366" },
  instagram: { label: "Instagram", icon: "Instagram", color: "#E1306C" },
  facebook: { label: "Facebook", icon: "Facebook", color: "#1877F2" },
  linkedin: { label: "LinkedIn", icon: "Linkedin", color: "#0A66C2" },
  maps: { label: "Google Maps", icon: "MapPin", color: "#34A853" },
  email: { label: "Email", icon: "Mail", color: "#EA4335" },
  custom: { label: "Custom URL", icon: "Link", color: "#C88A32" },
};

const DEFAULTS = [
  { enabled: true, type: "whatsapp", url: "", order: 0, position: "right" },
  { enabled: true, type: "phone", url: "", order: 1, position: "right" },
];

function hrefFor(a, settings) {
  const v = (a.url || "").trim();
  switch (a.type) {
    case "phone": return `tel:${(v || settings.phone || "").replace(/\s/g, "")}`;
    case "whatsapp": return `https://wa.me/${(v || settings.whatsapp || settings.phone || "").replace(/\D/g, "")}`;
    case "email": return `mailto:${v || settings.email || ""}`;
    default: return v || "#";
  }
}

function Group({ list, settings, side }) {
  const items = list.filter((a) => a.enabled !== false && (a.position || "right") === side)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  if (!items.length) return null;
  return (
    <div className={`fixed z-[80] bottom-24 md:bottom-8 ${side === "left" ? "left-4" : "right-4"} flex flex-col gap-3`} data-testid={`sticky-${side}`}>
      {items.map((a, i) => {
        const t = ACTION_TYPES[a.type] || ACTION_TYPES.custom;
        const Icon = Lucide[a.icon] || Lucide[t.icon] || Lucide.Link;
        return (
          <a
            key={i}
            href={hrefFor(a, settings)}
            target={a.new_tab === false || a.type === "phone" || a.type === "email" ? undefined : "_blank"}
            rel="noopener noreferrer"
            title={a.label || t.label}
            aria-label={a.label || t.label}
            data-testid={`sticky-btn-${a.type}`}
            className="w-12 h-12 rounded-full shadow-lift flex items-center justify-center transition-transform hover:scale-110"
            style={{ backgroundColor: a.color || t.color, color: a.icon_color || "#ffffff" }}
          >
            <Icon size={22} />
          </a>
        );
      })}
    </div>
  );
}

export default function StickyActions() {
  const { settings } = useSettings();
  // Each device list: use the saved array if defined (even empty => show nothing); else fall back to defaults.
  const mobile = Array.isArray(settings.sticky_mobile) ? settings.sticky_mobile : DEFAULTS;
  const desktop = Array.isArray(settings.sticky_desktop) ? settings.sticky_desktop : DEFAULTS;
  return (
    <>
      <div className="md:hidden"><Group list={mobile} settings={settings} side="left" /><Group list={mobile} settings={settings} side="right" /></div>
      <div className="hidden md:block"><Group list={desktop} settings={settings} side="left" /><Group list={desktop} settings={settings} side="right" /></div>
    </>
  );
}
